import { render, staticRenderFns } from "./AccountCreatorVideoUpvoted.vue?vue&type=template&id=35cc70db&scoped=true&"
import script from "./AccountCreatorVideoUpvoted.vue?vue&type=script&lang=js&"
export * from "./AccountCreatorVideoUpvoted.vue?vue&type=script&lang=js&"
import style0 from "./AccountCreatorVideoUpvoted.vue?vue&type=style&index=0&id=35cc70db&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35cc70db",
  null
  
)

export default component.exports